import { observable } from 'mobx';

export const inventoryStocks = observable({
    lineItems: [],
    isClickCollect: false
});
